<template>
  <!-- <div class="content pd-0 ">
      <slot name="content-header"></slot>
      <homevet v-if="activeGroup==9233" />
      <homeasset v-else-if="activeGroup==9237" />      
  </div>-->
  <div class="content-fixed">
    <div v-if="mode==0" class="container pd-x-0 pd-lg-x-30 pd-lg-y-20 home-apps">
      
      <div class="text-center">
        <h5 class="text-muted mg-b-0-f">Дүрээ сонгоно уу?</h5>
      </div>
      <div class="row">
        <div v-for="(grp, i) in myDefaultPages" :key="i" class="col-12">
          <label class="bd-l bd-3 bd-gray-200 pd-l-10 text-muted mg-b-0-f">{{ grp.title }}</label>
          <div class="row">
            <div
              v-for="(role, i) in grp.roles"
              :key="i"
              class="col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            >
              <div class="card app">
                <template v-if="role.version == 2">
                  <a
                    target="_blank"
                    :href="`${v2BaseUrl}/#/dl/${getToken()}/${
                      role.v2.type
                    }/${encodeURIComponent(role.v2.link)}/${role.v2.name}`"
                    role="button"
                    class="card-body text-center pd-15-f pos-relative"
                  >
                    <div style="display: flex; align-items: center; text-align: center; flex-direction: column;">
                      <div class="logo d-flex align-items-center justify-content-center mg-b-10">
                        <feather :type="role.icon" class="text-muted" style="width: 20px; height:20px"></feather>
                      </div>
                    </div>
                    <p class="card-text">
                      <span>{{ role.title }}</span>
                    </p>
                    <div class="pos-absolute t-0 r-5">
                      <feather type="external-link" class="text-muted" style="width: 12px; height:12px"></feather>
                    </div>
                  </a>
                </template>
                <template v-else-if="role.version == 8501">
                  <a
                    @click="showAttestModal()"
                    role="button"
                    class="card-body text-center pd-15-f"
                  >
                    <div style="display: flex; align-items: center; text-align: center; flex-direction: column;">
                      <div class="logo d-flex align-items-center justify-content-center mg-b-10">
                        <feather :type="role.icon" class="text-muted" style="width: 20px; height:20px"></feather>
                      </div>
                    </div>
                    <p class="card-text">
                      <span>{{ role.title }}</span>
                    </p>
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="role.rawLink"
                    role="button"
                    class="card-body text-center pd-15-f"
                  >
                    
                    <div style="display: flex; align-items: center; text-align: center; flex-direction: column;">
                      <div class="logo d-flex align-items-center justify-content-center mg-b-10">
                        <feather :type="role.icon" class="text-muted" style="width: 20px; height:20px"></feather>
                      </div>
                    </div>
                    <p class="card-text">
                      <span>{{ role.title }}</span>
                    </p>
                  </router-link>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode==1" class="container pd-x-0 pd-lg-x-30 text-center">
      <div>
        
        <div class="d-flex">
          <div class="alert alert-warning" role="alert">
            Танд тохирох түлхүүр үг сонголтод байхгүй бол <a target="_blank" href="mailto:delgerbayar@stf.gov.mn">delgerbayar@stf.gov.mn</a> хаягт санал болгох түлхүүр үгийг жагсааж явуулна уу.
          </div>
          <div class="mg-l-auto">
            <a @click="mdlHelpTip=true" href="javascript:void(0)" role="button" class="btn btn-info">
              <feather type="help-circle"></feather>
              Түлхүүр үг сонгох заавар
            </a>
          </div>
        </div>
        <div>
          <Steps :active="modeTab" direction="vertical" finish-status="success" simple style="padding: 30px">
            <Step title="Хувийн мэдээлэл бүртгэх" description="Хувийн мэдээллийг бүрэн бөглөснөөр түлхүүр үгийн тохируулга хэсэгт хандах эрх нээгдэнэ" ></Step>
            <Step title="Түлхүүр үг тохируулах" description="" ></Step>
            <Step title="Үндсэн мэдээлэл нягтлах" description="" ></Step>
          </Steps>
          <div>
            <div v-if="modeTab==0">
              <file-preview
                v-if="profileAgreement > 0"
                :id="profileAgreement"
                :force="true"
                :minusHeight="300"
              />
            </div>
            <div v-else-if="modeTab==1" style="height: calc(100vh - 300px); overflow: auto" class="kwrd_slctr">
              <loc-type-panel v-model="modeProfile.locTypeIds"
                :ids="modeProfile.locTypeIds" lkey="sc_db_keywords" titl="" :vmode="1"
              ></loc-type-panel>
            </div>

            <div v-else-if="modeTab==2">
            
              <div class="d-flex">
                <div class="wd-40p pd-r-20">
                  <h6 class="tx-uppercase tx-semibold mg-t-50 mg-b-15">Хувийн мэдээлэл</h6>
                  <task-info style="height: calc(100vh - 370px); overflow: auto"
                    :fields="tskInfo.fields"
                    :obj="tskInfo.obj"
                    :loaded="tskInfo.fetched"
                    :boxId="tskInfo.boxId"
                    :parentTask="tskInfo.parentTask"
                    v-if="tskInfo.rdy"
                  />
                </div>
                <div class="bd-l bd-1 bd-primary pd-l-20 wd-60p">
                  <h6 class="tx-uppercase tx-semibold mg-t-50 mg-b-15">Тохируулсан түлхүүр үгүүд</h6>
                  <loc-type-panel style="height: calc(100vh - 370px); overflow: auto"
                    :ids="modeProfile.locTypeIds" lkey="sc_db_keywords" titl="" :vmode="1" hidedroptree
                  ></loc-type-panel>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!--  -->
        <div class="text-center pd-20">
          <div v-if="modeTab==0" class="">
            <a @click="modeProfile.isTender=!modeProfile.isTender" role="button">
              <feather :type="`${modeProfile.isTender?'check-':''}square`" style="width: 24px; height: 24px"></feather>
              Гэрээг уншиж танилцсан
            </a>
            <a @click="nextStfStep()" role="button" class="btn btn-primary mg-l-10">Хувийн мэдээлэл шинэчлэх</a>
          </div>
          <div v-else-if="modeTab==1" class="btn-group">
            <a @click="modeTab=0" role="button" class="btn btn-light">Гэрээтэй дахин танилцах</a>
            <a @click="nextStfStep()" role="button" class="btn btn-success">Хадгалах</a>
            <a @click="modeTab= 2; nextStfStep()" role="button" class="btn btn-info">Үндсэн мэдээлэл нягтлах</a>
          </div>
          <div v-else-if="modeTab==2" class="btn-group">
            <a @click="modeTab= 1" role="button" class="btn btn-brand-01">Түлхүүр үг тохируулах</a>
            <a @click="$router.push('stf/researcher')" role="button" class="btn btn-success">Төслийн системд хандах</a>
          </div>
        </div>

      </div>
    </div>

    <b-modal
      size="xl"
      hide-footer
      :title="attestModal.title"
      v-model="attestModal.show"
    >
      <div>
        <!-- {{ attestModal.types }} -->
        <div class="row text-center">
          <div
            v-for="type in attestModal.types"
            :key="`rta-${type.id}`"
            class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <router-link
                :to="`/attestat/list/533/0/0/${type.id}`"
                role="button"
                class="card-body pd-y-50"
              >
                <p class="card-text tx-18">
                  <feather type="award"></feather>
                  <span class="mg-l-10">{{ type.s1 }}</span>
                </p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Түлхүүр үг сонгох заавар" v-model="mdlHelpTip" size="lg" centered hide-footer>
      <div v-html="helpTipUrl"></div>
    </b-modal>
  </div>
</template>

<script>
// import { hasOneOf } from "@/libs/tools";
// import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import config from "@/config";
const { mobAppActiveGroup } = config;
const { roleDefaultPages } = config;
import { hasOneOf } from "@/libs/tools";
import { getToken } from "@/libs/util";
import { request } from "@/api/all";

import { Steps, Step, Notification } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { mapActions } from "vuex";

export default {
  components: {
    Steps, Step, 
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypePanel: () => ({
      component: import("@/components/task/edit/components/locTypeMultiplePanel"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    // homevet: () => ({
    //   component: import("@/views/home/apps/vetmed"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // homeasset: () => ({
    //   component: import("@/views/home/apps/assetmanagement"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // lmsHome: () => ({
    //   component: import("@/views/modules/lms/index.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
  },
  data: () => ({
    helpTipUrl: null,
    mdlHelpTip: false,
    tskInfo:{
      rdy: false,
      fetched: false,
      fields: [],
      obj: {},
      boxId: null,
      parentTask: {},
    },
    mode: 0,
    modeTab: 0,
    modeProfile:{
      isTender: false,
      isCompleted: false,
      locTypeIds: [],
    },
    activeGroup: mobAppActiveGroup,
    learnMode: true,
    moduleKey: 0,
    myDefaultPages: [],
    v2BaseUrl: "",
    attestModal: {
      title: "Та тохирох дүрийг сонгоно уу",
      show: false,
      types: [],
    },
    profileAgreement: 0,

  }),
  mounted() {
    let self = this;
    // if(this.$store.state.app.activeGroup.id==9272){
    //   this.$router.push({name: this.$store.state.app.activeGroup.directPage.route});
    // }
      //console.log('mount fired uu', !this.hasPermission(["admin"]) );
    if(!this.hasPermission(["admin"]) && this.$store.state.app.activeGroup.id==9298){
      // console.log('1', !this.hasPermission(["admin"]) && hasOneOf(['doctor.stf.gov.mn'], this.$store.state.app.activeGroup.hostPro));
      if(hasOneOf(['doctor.stf.gov.mn'], this.$store.state.app.activeGroup.hostPro)){
        // console.log('dfsd')
        this.$router.push('dz/home');
        // this.$router.push({name: 'dzHome'})
        // this.$router.push('stf/researcher');
      } else if(hasOneOf(['project.stf.gov.mn'], this.$store.state.app.activeGroup.hostPro)){
        //console.log('dsf', this.$store.state.user.userInfo.qualityPerc!=undefined);
        if(this.$store.state.user.userInfo.qualityPerc!=undefined && this.$store.state.user.userInfo.qualityPerc!=null
        && this.$store.state.user.userInfo.qualityPerc>0) {
          //console.log('startup');
          this.$router.push('stf/researcher');
        } else if(this.hasPermission(["stf_shupz", 'stf_tax' ,'stf_gaali', 'stf_ubeg'])){
          this.$router.push('stf/researcher');
        }
        else {
          this.mode= 1;
          this.configureStf();
        }
      } 
    }
    else if ((this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249) && this.$store.state.user.userInfo.locType4Code == 'register' ){
      //this.$router.push({name: });
      this.$router.push({ name: 'lmsCourses', params: { md: 1, cnm: 'null', type: -1, d1: 'null', d2: 'null', } });
    }
    else{
      if(this.$store.state.app.activeGroup.directPage!=undefined && this.$store.state.app.activeGroup.directPage.has==true) {
        this.$router.push({name: this.$store.state.app.activeGroup.directPage.route});
      }else {
        //let myAccess=;
        this.v2BaseUrl = this.$store.state.app.activeGroup.v2BaseUrl;
        this.myDefaultPages = roleDefaultPages.filter(
          (x) => x.roles.filter((r) => self.hasPermission(r.role)).length > 0
        );
        this.myDefaultPages = this.myDefaultPages.map((x) => {
          return {
            id: x.id,
            title: x.title,
            roles: x.roles.filter((r) => self.hasPermission(r.role)),
          };
        });

        if (
          this.$store.state.app.isMobile &&
          this.hasPermission(["learningadmin", "learningteacher"])
        ) {
          this.$router.push("/lms/participant");
        }

        if (this.myDefaultPages.length == 1) {
          if (this.myDefaultPages[0].roles.length == 1) {
            this.$router.push(this.myDefaultPages[0].roles[0].rawLink);
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(["handleUserInfo"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    nextStfStep(obj){
      if(this.modeTab==0){
        if(this.modeProfile.isTender){
          this.nextStfAfter();
        }else{
          Notification.warning({
            message: "Гэрээг уншиж танилцаад цааш үргэлжлүүлэх боломжтой",
            title: "Мэдэгдэл",
            duration: 5000,
            type: "info",
            position: "bottom-right",
            offset: 50
          });
        }
      } else if(this.modeTab==1){
        if(this.modeProfile.locTypeIds.length>0 && this.modeProfile.locTypeIds.length<1500){
          this.modeProfile.isCompleted= true;
          this.nextStfAfter();
        }else{
          Notification.warning({
            message: "Түлхүүр үг хамгийн ихдээ 1500-г сонгох боломжтой",
            title: "Мэдэгдэл",
            duration: 5000,
            type: "info",
            position: "bottom-right",
            offset: 50
          });
        }
      } else if(this.modeTab==2){
        this.toggleBodyClass("addClass", "dynamic-locker");

        request({
          api: { method: "GET", url: "taskCore/GetDetailFields" },
          params: {  objectTypeId: 138 },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){

            this.tskInfo.fields = res.data.fields;
            if(obj!=undefined){
              this.tskInfo.rdy= true;
              this.tskInfo.obj= {data: {task: obj}};
            }
          }
        });

          // getDetailFields({ params: { objectTypeId: ot } }).then((res) => {
          //   if (res != false) {
          //     this.fields = res.data.fields;
          //     this.fetched = true;
          //   }
          // });
      }
    },
    nextStfAfter(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.modeProfile },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.handleUserInfo({ store: this.$store });
          if(this.modeTab==0){
            this.$router.push('/user/profile');
          }else if(this.modeTab==1){
            this.modeTab=2;
          }
        }
      });
    },
    configureStf(){
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(138, 10)
      );
      if (prj.length > 0) _pid = prj[0].id;
      //console.log('get inherited', _pid, this.$store.state.user.userInfo.profileId);
      let _uid = 0;
      if (this.manager) {
        _uid = this.propId;
      } else {
        if (this.id > 0) {
          _uid = this.id;
        } else {
          _uid = this.$store.state.user.userInfo.profileId;
        }
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: _uid,
          objectTypeId: 138,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          //console.log('res', res);
          this.modeProfile= res.data.task;
          if(this.modeProfile.isTender && this.modeProfile.isCompleted){
            //if()
            this.modeTab=2;
            this.nextStfStep(this.modeProfile);
          }else if(this.modeProfile.isTender && !this.modeProfile.isCompleted){
            this.modeTab=1;
          }
          // else if(this.modeProfile.isTender && !this.modeProfile.isCompleted){
          //   this.modeTab=1;
          // }
        }
      });

      let _agreement = this.$store.state.app.groupSettings.filter(x => x.key == "profileAgreement");
      if (_agreement.length > 0 && _agreement[0].value != undefined) {
        this.profileAgreement = _agreement[0].value;
      }

      let _tip = this.$store.state.app.groupSettings.filter(x => x.key == "keyTip");
      if (_tip.length > 0 && _tip[0].value != undefined) {
        this.helpTipUrl = _tip[0].value;
      }
    },
    getToken() {
      return getToken();
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    showAttestModal() {
      //attestMainType
      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: "attestMainType",
          getParentType: false,
        },
        store: this.$store,
      }).then((res) => {
        //this.handleLoading({ isLoading: false });
        if (res != false) {
          this.attestModal.types = res.data.types;
          this.attestModal.show = true;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.home-apps{
  max-width: 720px !important;
  .app{
    // height: 170px;
    box-shadow: 1px 1px 1px 2px rgb(0 0 0 / 4%);
    border-radius: 15px;
    border: 2px solid transparent;
    &:hover{
      border: 2px solid #bfc4ce;
    }
    .logo{
      width: 53px;
      height: 53px;
      background: rgba(0,0,0,0.05);
      border-radius: 15px;
    }
    .card-text{
      // font: bold 14px
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      line-height: 1.1;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;  
      overflow: hidden;
      min-height: 36px;
      max-height: 36px;
      margin-bottom: 0;
    }
  }
}
.el-cascader-panel{
  :nth-child(1){
    .el-checkbox{
      // display: none;
    }
  }
}
.el-cascader-panel > :nth-child(1){
  .el-cascader-menu__wrap{
    background: rgba(0, 0, 0, 0.05);
  }
  .el-checkbox{
    display: none;
  }
}
.el-cascader-panel > :nth-child(2){
  .el-cascader-menu__wrap{
    background: rgba(0, 0, 0, 0.05);
  }
  .el-checkbox{
    display: none;
  }
}

</style>